var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAwesomeClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.88,
    height: 18.88,
    viewBox: "0 0 18.88 18.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-clock",
    "data-name": "Icon awesome-clock",
    d: "M10,.563A9.44,9.44,0,1,0,19.443,10,9.438,9.438,0,0,0,10,.563Zm2.173,13.326-3.357-2.44a.46.46,0,0,1-.187-.369V4.673a.458.458,0,0,1,.457-.457h1.827a.458.458,0,0,1,.457.457V9.915l2.417,1.759a.456.456,0,0,1,.1.639L12.815,13.79A.46.46,0,0,1,12.176,13.889Z",
    transform: "translate(-0.563 -0.563)",
    fill: "#446fa2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAwesomeClock);
export default __webpack_public_path__ + "static/media/icon-awesome-clock.2383f261e3c05f28e9cefbaaa26a358d.svg";
export { ForwardRef as ReactComponent };